module.exports = __webpack_public_path__ + "static/media/logo_regime_general.57cf389e.bin";


//////////////////
// WEBPACK FOOTER
// ./src/Components/images/logo_regime_general
// module id = 105
// module chunks = 0